import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SiaHttpService } from '@sia/shared';
import { Credentials } from '../interfaces/credentials';

@Injectable({
  providedIn: 'root',
})
export class AuthApi {
  #http = inject(SiaHttpService);

  #apiController = 'authentications';

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  requestPassword(data: any) {
    return this.#http.post(`${this.#apiController}/request-pass`, data);
  }

  restorePassword(strategy: string, data: any) {
    return this.#http.post(`${this.#apiController}/restore-pass`, data);
  }

  resetPassword(pass: string, repass: string) {
    const data = {
      newPassword: pass,
      repeatPassword: repass,
    };
    return this.#http.post(`${this.#apiController}/reset-pass`, data, {});
  }

  login(credentials: Credentials) {
    return this.#http.post(`${this.#apiController}/login`, credentials);
  }

  validateTotp(otp: string) {
    return this.#http.post(`${this.#apiController}/validate-totp/${otp}`, {});
  }

  generateTotpQrCode(type: string) {
    return this.#http.get(`${this.#apiController}/totp-qrcode/${type}`, {});
  }

  getNewPinOtp(userIdentifier: string) {
    return this.#http.get(
      `${this.#apiController}/send-totp/${userIdentifier}`,
      {},
    );
  }

  getStoredToken(token: string) {
    let params = new HttpParams();
    params = params.set('token', `${token}`);
    return this.#http.get(`${this.#apiController}/stored`, { params });
  }

  impersonate(token: any, userId: number) {
    return this.#http.post(`${this.#apiController}/impersonate`, {
      token,
      userId,
    });
  }

  logout() {
    return this.#http.get(`${this.#apiController}/logout`, {});
  }

  refreshToken(token: any) {
    return this.#http.post(`${this.#apiController}/refresh-token`, { token });
  }
}
